/**
 * Constant variables
 */
const ACTIVATE_ACCOUNT = 'ACTIVATE_ACCOUNT';
const ACTIVATE_ACCOUNT_PERMISSION = 'ACTIVATE_ACCOUNT_PERMISSION';
const ACTIVATE_CUSTOMER_SYSTEM_GAME_TYPE = 'ACTIVATE_CUSTOMER_SYSTEM_GAME_TYPE';
const ARCHIVE_CUSTOMER_RUNNER_TICKET_ADDON = 'ARCHIVE_CUSTOMER_RUNNER_TICKET_ADDON';
const ARCHIVE_CUSTOMER_RUNNER_TICKET_HOOK = 'ARCHIVE_CUSTOMER_RUNNER_TICKET_HOOK';
const ARCHIVE_CUSTOMER_RUNNER_TICKET_SCHEME = 'ARCHIVE_CUSTOMER_RUNNER_TICKET_SCHEME';
const BYPASS_DEAL = 'BYPASS_DEAL';
const CANCEL_DEAL = 'CANCEL_DEAL';
const CLONE_CUSTOMER_RUNNER_CONTRACT = 'CLONE_CUSTOMER_RUNNER_CONTRACT';
const COPY_CUSTOMER_RUNNER_TICKET_ADDON = 'COPY_CUSTOMER_RUNNER_TICKET_ADDON';
const COPY_CUSTOMER_RUNNER_TICKET_HOOK = 'COPY_CUSTOMER_RUNNER_TICKET_HOOK';
const COPY_CUSTOMER_RUNNER_TICKET_SCHEME = 'COPY_CUSTOMER_RUNNER_TICKET_SCHEME';
const CREATE_ACCOUNT_PRINTER = 'CREATE_ACCOUNT_PRINTER';
const CREATE_ACCOUNT_WORKER = 'CREATE_ACCOUNT_WORKER';
const CREATE_CUSTOMER_DEAL_SCHEDULE = 'CREATE_CUSTOMER_DEAL_SCHEDULE';
const CREATE_CUSTOMER_DOWNLINE = 'CREATE_CUSTOMER_DOWNLINE';
const CREATE_CUSTOMER_PARTNER = 'CREATE_CUSTOMER_PARTNER';
const CREATE_CUSTOMER_RUNNER_CONTRACT = 'CREATE_CUSTOMER_RUNNER_CONTRACT';
const CREATE_CUSTOMER_RUNNER_TICKET_ADDON = 'CREATE_CUSTOMER_RUNNER_TICKET_ADDON';
const CREATE_CUSTOMER_RUNNER_TICKET_CONVERSION = 'CREATE_CUSTOMER_RUNNER_TICKET_CONVERSION';
const CREATE_CUSTOMER_RUNNER_TICKET_HOOK = 'CREATE_CUSTOMER_RUNNER_TICKET_HOOK';
const CREATE_CUSTOMER_RUNNER_TICKET_SCHEME = 'CREATE_CUSTOMER_RUNNER_TICKET_SCHEME';
const CREATE_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGIN = 'CREATE_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGIN';
const CREATE_DEAL = 'CREATE_DEAL';
const CREATE_DRAW = 'CREATE_DRAW';
const CREATE_SYSTEM_PERMISSION = 'CREATE_SYSTEM_PERMISSION';
const DEACTIVATE_ACCOUNT = 'DEACTIVATE_ACCOUNT';
const DEACTIVATE_ACCOUNT_PERMISSION = 'DEACTIVATE_ACCOUNT_PERMISSION';
const DEACTIVATE_CUSTOMER_SYSTEM_GAME_TYPE = 'DEACTIVATE_CUSTOMER_SYSTEM_GAME_TYPE';
const DELETE_ACCOUNT_PRINTER = 'DELETE_ACCOUNT_PRINTER';
const DELETE_ACCOUNT_SESSION = 'DELETE_ACCOUNT_SESSION';
const DELETE_CUSTOMER_DEALER_EAT_LIMIT = 'DELETE_CUSTOMER_DEALER_EAT_LIMIT';
const DELETE_CUSTOMER_DEALER_TANK_LIMIT = 'DELETE_CUSTOMER_DEALER_TANK_LIMIT';
const DELETE_CUSTOMER_DEAL_SCHEDULE = 'DELETE_CUSTOMER_DEAL_SCHEDULE';
const DELETE_CUSTOMER_REQUEST_LIMIT = 'DELETE_CUSTOMER_REQUEST_LIMIT';
const DELETE_CUSTOMER_REWARD_LIMIT = 'DELETE_CUSTOMER_REWARD_LIMIT';
const DELETE_CUSTOMER_RUNNER_CONTRACT = 'DELETE_CUSTOMER_RUNNER_CONTRACT';
const DELETE_CUSTOMER_RUNNER_TICKET_ADDON = 'DELETE_CUSTOMER_RUNNER_TICKET_ADDON';
const DELETE_CUSTOMER_RUNNER_TICKET_CONVERSION = 'DELETE_CUSTOMER_RUNNER_TICKET_CONVERSION';
const DELETE_CUSTOMER_RUNNER_TICKET_HOOK = 'DELETE_CUSTOMER_RUNNER_TICKET_HOOK';
const DELETE_CUSTOMER_RUNNER_TICKET_SCHEME = 'DELETE_CUSTOMER_RUNNER_TICKET_SCHEME';
const DELETE_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGIN = 'DELETE_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGIN';
const DELETE_SYSTEM_PERMISSION = 'DELETE_SYSTEM_PERMISSION';
const EDIT_DEAL = 'EDIT_DEAL';
const EXPORT_DRAW_SYSTEM_GAME_TYPE_REPORT = 'EXPORT_DRAW_SYSTEM_GAME_TYPE_REPORT';
const GET_ACCOUNT = 'GET_ACCOUNT';
const GET_ACCOUNT_ACTIVITY = 'GET_ACCOUNT_ACTIVITY';
const GET_ACCOUNT_PERMISSION = 'GET_ACCOUNT_PERMISSION';
const GET_ACCOUNT_PRINTER = 'GET_ACCOUNT_PRINTER';
const GET_ACCOUNT_SESSION = 'GET_ACCOUNT_SESSION';
const GET_ACCOUNT_WORKER = 'GET_ACCOUNT_WORKER';
const GET_CUSTOMER = 'GET_CUSTOMER';
const GET_CUSTOMER_ANCESTOR_RUNNER_LIMIT = 'GET_CUSTOMER_ANCESTOR_RUNNER_LIMIT';
const GET_CUSTOMER_DEALER_EAT_LIMIT = 'GET_CUSTOMER_DEALER_EAT_LIMIT';
const GET_CUSTOMER_DEALER_FIGHT = 'GET_CUSTOMER_DEALER_FIGHT';
const GET_CUSTOMER_DEALER_PROPERTY = 'GET_CUSTOMER_DEALER_PROPERTY';
const GET_CUSTOMER_DEALER_TANK_LIMIT = 'GET_CUSTOMER_DEALER_TANK_LIMIT';
const GET_CUSTOMER_DEAL_SCHEDULE = 'GET_CUSTOMER_DEAL_SCHEDULE';
const GET_CUSTOMER_DOWNLINE = 'GET_CUSTOMER_DOWNLINE';
const GET_CUSTOMER_PARTNER = 'GET_CUSTOMER_PARTNER';
const GET_CUSTOMER_PROPERTY = 'GET_CUSTOMER_PROPERTY';
const GET_CUSTOMER_RELATIONSHIP = 'GET_CUSTOMER_RELATIONSHIP';
const GET_CUSTOMER_REQUEST_LIMIT = 'GET_CUSTOMER_REQUEST_LIMIT';
const GET_CUSTOMER_REQUEST_LIMIT_PACKAGE = 'GET_CUSTOMER_REQUEST_LIMIT_PACKAGE';
const GET_CUSTOMER_REWARD_LIMIT = 'GET_CUSTOMER_REWARD_LIMIT';
const GET_CUSTOMER_REWARD_LIMIT_PACKAGE = 'GET_CUSTOMER_REWARD_LIMIT_PACKAGE';
const GET_CUSTOMER_RUNNER_CONTRACT = 'GET_CUSTOMER_RUNNER_CONTRACT';
const GET_CUSTOMER_RUNNER_PROPERTY = 'GET_CUSTOMER_RUNNER_PROPERTY';
const GET_CUSTOMER_RUNNER_TICKET_ADDON = 'GET_CUSTOMER_RUNNER_TICKET_ADDON';
const GET_CUSTOMER_RUNNER_TICKET_CONVERSION = 'GET_CUSTOMER_RUNNER_TICKET_CONVERSION';
const GET_CUSTOMER_RUNNER_TICKET_HOOK = 'GET_CUSTOMER_RUNNER_TICKET_HOOK';
const GET_CUSTOMER_RUNNER_TICKET_SCHEME = 'GET_CUSTOMER_RUNNER_TICKET_SCHEME';
const GET_CUSTOMER_SYSTEM_GAME_TYPE = 'GET_CUSTOMER_SYSTEM_GAME_TYPE';
const GET_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGIN = 'GET_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGIN';
const GET_DEAL = 'GET_DEAL';
const GET_DEAL_LIMIT = 'GET_DEAL_LIMIT';
const GET_DEAL_RECEIPT = 'GET_DEAL_RECEIPT';
const GET_DRAW = 'GET_DRAW';
const GET_DRAW_CUSTOMER = 'GET_DRAW_CUSTOMER';
const GET_DRAW_SYSTEM_GAME_CREDIT = 'GET_DRAW_SYSTEM_GAME_CREDIT';
const GET_DRAW_SYSTEM_GAME_TYPE = 'GET_DRAW_SYSTEM_GAME_TYPE';
const GET_DRAW_SYSTEM_GAME_TYPE_ATE_VOLUME = 'GET_DRAW_SYSTEM_GAME_TYPE_ATE_VOLUME';
const GET_DRAW_SYSTEM_GAME_TYPE_ATE_VOLUME_RECIPE = 'GET_DRAW_SYSTEM_GAME_TYPE_ATE_VOLUME_RECIPE';
const GET_DRAW_SYSTEM_GAME_TYPE_INVOICE = 'GET_DRAW_SYSTEM_GAME_TYPE_INVOICE';
const GET_DRAW_SYSTEM_GAME_TYPE_OVERALL_VOLUME = 'GET_DRAW_SYSTEM_GAME_TYPE_OVERALL_VOLUME';
const GET_DRAW_SYSTEM_GAME_TYPE_OVERALL_VOLUME_RECIPE = 'GET_DRAW_SYSTEM_GAME_TYPE_OVERALL_VOLUME_RECIPE';
const GET_DRAW_SYSTEM_GAME_TYPE_REPORT = 'GET_DRAW_SYSTEM_GAME_TYPE_REPORT';
const GET_DRAW_SYSTEM_GAME_TYPE_REPORT_STRIKE_OVERVIEW = 'GET_DRAW_SYSTEM_GAME_TYPE_REPORT_STRIKE_OVERVIEW';
const GET_DRAW_SYSTEM_GAME_TYPE_REPORT_VOLUME = 'GET_DRAW_SYSTEM_GAME_TYPE_REPORT_VOLUME';
const GET_DRAW_SYSTEM_GAME_TYPE_REPORT_VOLUME_RECIPE = 'GET_DRAW_SYSTEM_GAME_TYPE_REPORT_VOLUME_RECIPE';
const GET_DRAW_SYSTEM_GAME_TYPE_RESULT = 'GET_DRAW_SYSTEM_GAME_TYPE_RESULT';
const GET_DRAW_SYSTEM_GAME_TYPE_TANKED_VOLUME = 'GET_DRAW_SYSTEM_GAME_TYPE_TANKED_VOLUME';
const GET_DRAW_SYSTEM_GAME_TYPE_TANKED_VOLUME_RECIPE = 'GET_DRAW_SYSTEM_GAME_TYPE_TANKED_VOLUME_RECIPE';
const GET_SYSTEM_GAME = 'GET_SYSTEM_GAME';
const GET_SYSTEM_GAME_CATEGORY = 'GET_SYSTEM_GAME_CATEGORY';
const GET_SYSTEM_GAME_PRIZE = 'GET_SYSTEM_GAME_PRIZE';
const GET_SYSTEM_GAME_TYPE = 'GET_SYSTEM_GAME_TYPE';
const GET_SYSTEM_PERMISSION = 'GET_SYSTEM_PERMISSION';
const GET_SYSTEM_TICKET_NUMBER_PLUGIN = 'GET_SYSTEM_TICKET_NUMBER_PLUGIN';
const GET_SYSTEM_TICKET_NUMBER_PLUGIN_PERMUTATION_MODEL = 'GET_SYSTEM_TICKET_NUMBER_PLUGIN_PERMUTATION_MODEL';
const GET_SYSTEM_TICKET_NUMBER_PLUGIN_RUNNING_MODEL = 'GET_SYSTEM_TICKET_NUMBER_PLUGIN_RUNNING_MODEL';
const GET_SYSTEM_TRANSLATION = 'GET_SYSTEM_TRANSLATION';
const PRINT_DEAL_RECEIPT = 'PRINT_DEAL_RECEIPT';
const PRINT_DRAW_SYSTEM_GAME_TYPE_INVOICE = 'PRINT_DRAW_SYSTEM_GAME_TYPE_INVOICE';
const PRINT_DRAW_SYSTEM_GAME_TYPE_RESULT = 'PRINT_DRAW_SYSTEM_GAME_TYPE_RESULT';
const PROCESS_DEAL = 'PROCESS_DEAL';
const RECOVER_ACCOUNT = 'RECOVER_ACCOUNT';
const RECOVER_ACCOUNT_WORKER = 'RECOVER_ACCOUNT_WORKER';
const RECOVER_CUSTOMER_DOWNLINE = 'RECOVER_CUSTOMER_DOWNLINE';
const RECOVER_CUSTOMER_PARTNER = 'RECOVER_CUSTOMER_PARTNER';
const REFRESH_ACCOUNT_API_KEY = 'REFRESH_ACCOUNT_API_KEY';
const REFRESH_ACCOUNT_ONE_TIME_PASSWORD_SECRET = 'REFRESH_ACCOUNT_ONE_TIME_PASSWORD_SECRET';
const REMOVE_ACCOUNT = 'REMOVE_ACCOUNT';
const REMOVE_ACCOUNT_WORKER = 'REMOVE_ACCOUNT_WORKER';
const REMOVE_CUSTOMER_DOWNLINE = 'REMOVE_CUSTOMER_DOWNLINE';
const REMOVE_CUSTOMER_PARTNER = 'REMOVE_CUSTOMER_PARTNER';
const REORDER_CUSTOMER_RUNNER_TICKET_SCHEME = 'REORDER_CUSTOMER_RUNNER_TICKET_SCHEME';
const RESTORE_DEAL = 'RESTORE_DEAL';
const RESYNCHRONIZE_DRAW_SYSTEM_GAME_TYPE_CONTRACT = 'RESYNCHRONIZE_DRAW_SYSTEM_GAME_TYPE_CONTRACT';
const SAVE_CUSTOMER_DEALER_EAT_LIMIT = 'SAVE_CUSTOMER_DEALER_EAT_LIMIT';
const SAVE_CUSTOMER_DEALER_TANK_LIMIT = 'SAVE_CUSTOMER_DEALER_TANK_LIMIT';
const SAVE_CUSTOMER_REQUEST_LIMIT = 'SAVE_CUSTOMER_REQUEST_LIMIT';
const SAVE_CUSTOMER_REWARD_LIMIT = 'SAVE_CUSTOMER_REWARD_LIMIT';
const SHARE_DEAL_RECEIPT = 'SHARE_DEAL_RECEIPT';
const SHARE_DRAW_SYSTEM_GAME_TYPE_INVOICE = 'SHARE_DRAW_SYSTEM_GAME_TYPE_INVOICE';
const SHARE_DRAW_SYSTEM_GAME_TYPE_RESULT = 'SHARE_DRAW_SYSTEM_GAME_TYPE_RESULT';
const UNARCHIVE_CUSTOMER_RUNNER_TICKET_ADDON = 'UNARCHIVE_CUSTOMER_RUNNER_TICKET_ADDON';
const UNARCHIVE_CUSTOMER_RUNNER_TICKET_HOOK = 'UNARCHIVE_CUSTOMER_RUNNER_TICKET_HOOK';
const UNARCHIVE_CUSTOMER_RUNNER_TICKET_SCHEME = 'UNARCHIVE_CUSTOMER_RUNNER_TICKET_SCHEME';
const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
const UPDATE_ACCOUNT_PASSWORD = 'UPDATE_ACCOUNT_PASSWORD';
const UPDATE_ACCOUNT_PRINTER = 'UPDATE_ACCOUNT_PRINTER';
const UPDATE_ACCOUNT_USERNAME = 'UPDATE_ACCOUNT_USERNAME';
const UPDATE_ACCOUNT_WORKER = 'UPDATE_ACCOUNT_WORKER';
const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
const UPDATE_CUSTOMER_DEALER_EAT_LIMIT = 'UPDATE_CUSTOMER_DEALER_EAT_LIMIT';
const UPDATE_CUSTOMER_DEALER_FIGHT = 'UPDATE_CUSTOMER_DEALER_FIGHT';
const UPDATE_CUSTOMER_DEALER_PROPERTY = 'UPDATE_CUSTOMER_DEALER_PROPERTY';
const UPDATE_CUSTOMER_DEALER_TANK_LIMIT = 'UPDATE_CUSTOMER_DEALER_TANK_LIMIT';
const UPDATE_CUSTOMER_DOWNLINE = 'UPDATE_CUSTOMER_DOWNLINE';
const UPDATE_CUSTOMER_PROPERTY = 'UPDATE_CUSTOMER_PROPERTY';
const UPDATE_CUSTOMER_RUNNER_CONTRACT = 'UPDATE_CUSTOMER_RUNNER_CONTRACT';
const UPDATE_CUSTOMER_RUNNER_CONTRACT_DISCOUNT = 'UPDATE_CUSTOMER_RUNNER_CONTRACT_DISCOUNT';
const UPDATE_CUSTOMER_RUNNER_CONTRACT_PAYOUT = 'UPDATE_CUSTOMER_RUNNER_CONTRACT_PAYOUT';
const UPDATE_CUSTOMER_RUNNER_PROPERTY = 'UPDATE_CUSTOMER_RUNNER_PROPERTY';
const UPDATE_CUSTOMER_RUNNER_PROPERTY_BASE_PERCENT = 'UPDATE_CUSTOMER_RUNNER_PROPERTY_BASE_PERCENT';
const UPDATE_CUSTOMER_RUNNER_PROPERTY_LIMIT_MODE = 'UPDATE_CUSTOMER_RUNNER_PROPERTY_LIMIT_MODE';
const UPDATE_CUSTOMER_RUNNER_PROPERTY_OFFSET_PERCENT = 'UPDATE_CUSTOMER_RUNNER_PROPERTY_OFFSET_PERCENT';
const UPDATE_CUSTOMER_RUNNER_TICKET_ADDON = 'UPDATE_CUSTOMER_RUNNER_TICKET_ADDON';
const UPDATE_CUSTOMER_RUNNER_TICKET_ADDON_ENTRY = 'UPDATE_CUSTOMER_RUNNER_TICKET_ADDON_ENTRY';
const UPDATE_CUSTOMER_RUNNER_TICKET_CONVERSION = 'UPDATE_CUSTOMER_RUNNER_TICKET_CONVERSION';
const UPDATE_CUSTOMER_RUNNER_TICKET_HOOK = 'UPDATE_CUSTOMER_RUNNER_TICKET_HOOK';
const UPDATE_CUSTOMER_RUNNER_TICKET_HOOK_ENTRY = 'UPDATE_CUSTOMER_RUNNER_TICKET_HOOK_ENTRY';
const UPDATE_CUSTOMER_RUNNER_TICKET_SCHEME = 'UPDATE_CUSTOMER_RUNNER_TICKET_SCHEME';
const UPDATE_CUSTOMER_RUNNER_TICKET_SCHEME_ENTRY = 'UPDATE_CUSTOMER_RUNNER_TICKET_SCHEME_ENTRY';
const UPDATE_DEAL = 'UPDATE_DEAL';
const UPDATE_DRAW_SYSTEM_GAME_TYPE_RESULT = 'UPDATE_DRAW_SYSTEM_GAME_TYPE_RESULT';
const UPDATE_SYSTEM_TRANSLATION = 'UPDATE_SYSTEM_TRANSLATION';
module.exports = {
  ACTIVATE_ACCOUNT,
  ACTIVATE_ACCOUNT_PERMISSION,
  ACTIVATE_CUSTOMER_SYSTEM_GAME_TYPE,
  ARCHIVE_CUSTOMER_RUNNER_TICKET_ADDON,
  ARCHIVE_CUSTOMER_RUNNER_TICKET_HOOK,
  ARCHIVE_CUSTOMER_RUNNER_TICKET_SCHEME,
  BYPASS_DEAL,
  CANCEL_DEAL,
  CLONE_CUSTOMER_RUNNER_CONTRACT,
  COPY_CUSTOMER_RUNNER_TICKET_ADDON,
  COPY_CUSTOMER_RUNNER_TICKET_HOOK,
  COPY_CUSTOMER_RUNNER_TICKET_SCHEME,
  CREATE_ACCOUNT_PRINTER,
  CREATE_ACCOUNT_WORKER,
  CREATE_CUSTOMER_DEAL_SCHEDULE,
  CREATE_CUSTOMER_DOWNLINE,
  CREATE_CUSTOMER_PARTNER,
  CREATE_CUSTOMER_RUNNER_CONTRACT,
  CREATE_CUSTOMER_RUNNER_TICKET_ADDON,
  CREATE_CUSTOMER_RUNNER_TICKET_CONVERSION,
  CREATE_CUSTOMER_RUNNER_TICKET_HOOK,
  CREATE_CUSTOMER_RUNNER_TICKET_SCHEME,
  CREATE_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGIN,
  CREATE_DEAL,
  CREATE_DRAW,
  CREATE_SYSTEM_PERMISSION,
  DEACTIVATE_ACCOUNT,
  DEACTIVATE_ACCOUNT_PERMISSION,
  DEACTIVATE_CUSTOMER_SYSTEM_GAME_TYPE,
  DELETE_ACCOUNT_PRINTER,
  DELETE_ACCOUNT_SESSION,
  DELETE_CUSTOMER_DEALER_EAT_LIMIT,
  DELETE_CUSTOMER_DEALER_TANK_LIMIT,
  DELETE_CUSTOMER_DEAL_SCHEDULE,
  DELETE_CUSTOMER_REQUEST_LIMIT,
  DELETE_CUSTOMER_REWARD_LIMIT,
  DELETE_CUSTOMER_RUNNER_CONTRACT,
  DELETE_CUSTOMER_RUNNER_TICKET_ADDON,
  DELETE_CUSTOMER_RUNNER_TICKET_CONVERSION,
  DELETE_CUSTOMER_RUNNER_TICKET_HOOK,
  DELETE_CUSTOMER_RUNNER_TICKET_SCHEME,
  DELETE_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGIN,
  DELETE_SYSTEM_PERMISSION,
  EDIT_DEAL,
  EXPORT_DRAW_SYSTEM_GAME_TYPE_REPORT,
  GET_ACCOUNT,
  GET_ACCOUNT_ACTIVITY,
  GET_ACCOUNT_PERMISSION,
  GET_ACCOUNT_PRINTER,
  GET_ACCOUNT_SESSION,
  GET_ACCOUNT_WORKER,
  GET_CUSTOMER,
  GET_CUSTOMER_ANCESTOR_RUNNER_LIMIT,
  GET_CUSTOMER_DEALER_EAT_LIMIT,
  GET_CUSTOMER_DEALER_FIGHT,
  GET_CUSTOMER_DEALER_PROPERTY,
  GET_CUSTOMER_DEALER_TANK_LIMIT,
  GET_CUSTOMER_DEAL_SCHEDULE,
  GET_CUSTOMER_DOWNLINE,
  GET_CUSTOMER_PARTNER,
  GET_CUSTOMER_PROPERTY,
  GET_CUSTOMER_RELATIONSHIP,
  GET_CUSTOMER_REQUEST_LIMIT,
  GET_CUSTOMER_REQUEST_LIMIT_PACKAGE,
  GET_CUSTOMER_REWARD_LIMIT,
  GET_CUSTOMER_REWARD_LIMIT_PACKAGE,
  GET_CUSTOMER_RUNNER_CONTRACT,
  GET_CUSTOMER_RUNNER_PROPERTY,
  GET_CUSTOMER_RUNNER_TICKET_ADDON,
  GET_CUSTOMER_RUNNER_TICKET_CONVERSION,
  GET_CUSTOMER_RUNNER_TICKET_HOOK,
  GET_CUSTOMER_RUNNER_TICKET_SCHEME,
  GET_CUSTOMER_SYSTEM_GAME_TYPE,
  GET_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGIN,
  GET_DEAL,
  GET_DEAL_LIMIT,
  GET_DEAL_RECEIPT,
  GET_DRAW,
  GET_DRAW_CUSTOMER,
  GET_DRAW_SYSTEM_GAME_CREDIT,
  GET_DRAW_SYSTEM_GAME_TYPE,
  GET_DRAW_SYSTEM_GAME_TYPE_ATE_VOLUME,
  GET_DRAW_SYSTEM_GAME_TYPE_ATE_VOLUME_RECIPE,
  GET_DRAW_SYSTEM_GAME_TYPE_INVOICE,
  GET_DRAW_SYSTEM_GAME_TYPE_OVERALL_VOLUME,
  GET_DRAW_SYSTEM_GAME_TYPE_OVERALL_VOLUME_RECIPE,
  GET_DRAW_SYSTEM_GAME_TYPE_REPORT,
  GET_DRAW_SYSTEM_GAME_TYPE_REPORT_STRIKE_OVERVIEW,
  GET_DRAW_SYSTEM_GAME_TYPE_REPORT_VOLUME,
  GET_DRAW_SYSTEM_GAME_TYPE_REPORT_VOLUME_RECIPE,
  GET_DRAW_SYSTEM_GAME_TYPE_RESULT,
  GET_DRAW_SYSTEM_GAME_TYPE_TANKED_VOLUME,
  GET_DRAW_SYSTEM_GAME_TYPE_TANKED_VOLUME_RECIPE,
  GET_SYSTEM_GAME,
  GET_SYSTEM_GAME_CATEGORY,
  GET_SYSTEM_GAME_PRIZE,
  GET_SYSTEM_GAME_TYPE,
  GET_SYSTEM_PERMISSION,
  GET_SYSTEM_TICKET_NUMBER_PLUGIN,
  GET_SYSTEM_TICKET_NUMBER_PLUGIN_PERMUTATION_MODEL,
  GET_SYSTEM_TICKET_NUMBER_PLUGIN_RUNNING_MODEL,
  GET_SYSTEM_TRANSLATION,
  PRINT_DEAL_RECEIPT,
  PRINT_DRAW_SYSTEM_GAME_TYPE_INVOICE,
  PRINT_DRAW_SYSTEM_GAME_TYPE_RESULT,
  PROCESS_DEAL,
  RECOVER_ACCOUNT,
  RECOVER_ACCOUNT_WORKER,
  RECOVER_CUSTOMER_DOWNLINE,
  RECOVER_CUSTOMER_PARTNER,
  REFRESH_ACCOUNT_API_KEY,
  REFRESH_ACCOUNT_ONE_TIME_PASSWORD_SECRET,
  REMOVE_ACCOUNT,
  REMOVE_ACCOUNT_WORKER,
  REMOVE_CUSTOMER_DOWNLINE,
  REMOVE_CUSTOMER_PARTNER,
  REORDER_CUSTOMER_RUNNER_TICKET_SCHEME,
  RESTORE_DEAL,
  RESYNCHRONIZE_DRAW_SYSTEM_GAME_TYPE_CONTRACT,
  SAVE_CUSTOMER_DEALER_EAT_LIMIT,
  SAVE_CUSTOMER_DEALER_TANK_LIMIT,
  SAVE_CUSTOMER_REQUEST_LIMIT,
  SAVE_CUSTOMER_REWARD_LIMIT,
  SHARE_DEAL_RECEIPT,
  SHARE_DRAW_SYSTEM_GAME_TYPE_INVOICE,
  SHARE_DRAW_SYSTEM_GAME_TYPE_RESULT,
  UNARCHIVE_CUSTOMER_RUNNER_TICKET_ADDON,
  UNARCHIVE_CUSTOMER_RUNNER_TICKET_HOOK,
  UNARCHIVE_CUSTOMER_RUNNER_TICKET_SCHEME,
  UPDATE_ACCOUNT,
  UPDATE_ACCOUNT_PASSWORD,
  UPDATE_ACCOUNT_PRINTER,
  UPDATE_ACCOUNT_USERNAME,
  UPDATE_ACCOUNT_WORKER,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_DEALER_EAT_LIMIT,
  UPDATE_CUSTOMER_DEALER_FIGHT,
  UPDATE_CUSTOMER_DEALER_PROPERTY,
  UPDATE_CUSTOMER_DEALER_TANK_LIMIT,
  UPDATE_CUSTOMER_DOWNLINE,
  UPDATE_CUSTOMER_PROPERTY,
  UPDATE_CUSTOMER_RUNNER_CONTRACT,
  UPDATE_CUSTOMER_RUNNER_CONTRACT_DISCOUNT,
  UPDATE_CUSTOMER_RUNNER_CONTRACT_PAYOUT,
  UPDATE_CUSTOMER_RUNNER_PROPERTY,
  UPDATE_CUSTOMER_RUNNER_PROPERTY_BASE_PERCENT,
  UPDATE_CUSTOMER_RUNNER_PROPERTY_LIMIT_MODE,
  UPDATE_CUSTOMER_RUNNER_PROPERTY_OFFSET_PERCENT,
  UPDATE_CUSTOMER_RUNNER_TICKET_ADDON,
  UPDATE_CUSTOMER_RUNNER_TICKET_ADDON_ENTRY,
  UPDATE_CUSTOMER_RUNNER_TICKET_CONVERSION,
  UPDATE_CUSTOMER_RUNNER_TICKET_HOOK,
  UPDATE_CUSTOMER_RUNNER_TICKET_HOOK_ENTRY,
  UPDATE_CUSTOMER_RUNNER_TICKET_SCHEME,
  UPDATE_CUSTOMER_RUNNER_TICKET_SCHEME_ENTRY,
  UPDATE_DEAL,
  UPDATE_DRAW_SYSTEM_GAME_TYPE_RESULT,
  UPDATE_SYSTEM_TRANSLATION,
};
